/* eslint-disable */

let privileges = {
	can: {
		access: 1,
		create: 2,
		update: 8,
		delete: 4
	},
	canAccess: function (myPrivileges) {
		return (myPrivileges & this.can.access) === this.can.access
	},
	canCreate: function (myPrivileges) {
		return (myPrivileges & this.can.create) === this.can.create
	},
	canUpdate: function (myPrivileges) {
		return (myPrivileges & this.can.update) === this.can.update
	},
	canDelete: function (myPrivileges) {
		return (myPrivileges & this.can.delete) === this.can.delete
	},
	grantAccess: function (myPrivileges) {
		return myPrivileges |= this.can.access
	},
	grantCreate: function (myPrivileges) {
		return myPrivileges |= this.can.create
	},
	grantUpdate: function (myPrivileges) {
		return myPrivileges |= this.can.update
	},
	grantDelete: function (myPrivileges) {
		return myPrivileges |= this.can.delete
	},
	revokeAccess: function (myPrivileges) {
		return myPrivileges &= ~this.can.access
	},
	revokeCreate: function (myPrivileges) {
		return myPrivileges &= ~this.can.create
	},
	revokeUpdate: function (myPrivileges) {
		return myPrivileges &= ~this.can.update
	},
	revokeDelete: function (myPrivileges) {
		return myPrivileges &= ~this.can.delete
	}
}

export default privileges
